import { GetSwitchKeyNameList } from '@/axios/IDevice'

export async function getSwitchKeyNameList({allactionlist = [], ChannelSkus = [] }) {
  if (!Array.isArray(allactionlist) || allactionlist.length === 0) return

  // 找出需要请求的设备 ID
  const needEditVDevicesID = allactionlist
    .filter(({ ClassSku }) => ChannelSkus.includes(ClassSku))
    .map(({ VDeviceId }) => VDeviceId)

  if (needEditVDevicesID.length === 0) return

  // 请求接口
  let res
  try {
    res = await GetSwitchKeyNameList({
      VDeviceIds: needEditVDevicesID,
      Type: 0,
    })
  } catch (e) {
    console.error('GetSwitchKeyNameList 请求失败:', e)
    return
  }

  const Result = Array.isArray(res?.Result) ? res.Result : []

  // 把 Result 转换成 Map，加快查找速度
  const resultMap = new Map(
    Result.map(item => [`${item.VDeviceId}-${item.NameId}-${item.MessageType}`, item.Name])
  )


  // 更新 allactionlist 里的 ActionList
  allactionlist.forEach(device => {
    if (!ChannelSkus.includes(device.ClassSku)) return

    device.ActionList?.forEach(action => {
      const key = `${device.VDeviceId}-${action.ChannelId}-${action.MsgType?.slice(0, -2)}`
      const name = resultMap.get(key)
      if (name) {
        action.CnDesc = name
      }
    })
  })
}

export async function getSwitchKeyNameList2({actionlist = [], VDeviceId = '' }) {

  if (!Array.isArray(actionlist) || actionlist.length === 0) return

  if(!VDeviceId) return

  // 请求接口
  let res
  try {
    res = await GetSwitchKeyNameList({
      VDeviceIds: VDeviceId.split(','),
      Type: 0,
    })
  } catch (e) {
    console.error('GetSwitchKeyNameList 请求失败:', e)
    return
  }

  const Result = Array.isArray(res?.Result) ? res.Result : []

  // 把 Result 转换成 Map，加快查找速度
  const resultMap = new Map(
    Result.map(item => [`${item.NameId}-${item.MessageType}`, item.Name])
  )


  // 更新 allactionlist 里的 ActionList
  actionlist.forEach(action => {

      const key = `${action.ChannelId}-${action.MsgType?.slice(0, -2)}`
      const name = resultMap.get(key)
      if (name) {
        action.CnDesc = name
      }
  })
}
